(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/config/menu-config/assets/javascripts/navigation-menu.js') >= 0) return;  svs.modules.push('/components/config/menu-config/assets/javascripts/navigation-menu.js');

'use strict';

var loginAndCreateUserLinks = document.querySelectorAll('.nav-menu-header-button, .navigation-user-logged-out a');
for (var i = 0, length = loginAndCreateUserLinks.length; i < length; i++) {
  var link = loginAndCreateUserLinks[i];

  link.addEventListener('click', function(e) {
    e.preventDefault();

    const target = e.currentTarget;

    svs.components.analytics.trackEvent({
      category: 'right menu',
      action: target.dataset?.track,
      opt_label: target.dataset?.track
    }, () => {
      location.href = target.getAttribute('href') + '?returnUrl=' + svs.utils.url.currentPathEncodedParams();
    });
  });
}

const logger = new svs.core.log.Logger('config:menu-config');

function startDeposit() {
  const depositValues = {
    amount: 50,
    skipStepOne: false
  };
  const storageTimeInMinutes = 30;
  svs.components.Storage.browser.set('depositValues', 'quick-deposit', depositValues, storageTimeInMinutes, (error) => {
    if (error) {
      logger.warn(`Failed to set depositValues: ${error}`);
    }
  });
}

const depositPlayBtn = document.querySelector('.js-navigation-user-deposit-play');

depositPlayBtn && depositPlayBtn.addEventListener('click', function() {
  const loginUrl = svs.core.urlMapping.get('loginHome');
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  startDeposit();
  const target = isLoggedIn ? svs.core.urlMapping.get('quickDeposit') : loginUrl;
  svs.utils.url.navigate(target);
});


 })(window);